export default __webpack_public_path__ + "static/media/aircare-inside-1.e3a6c0ca.png";